import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueSocketIO from 'vue-socket.io'
import VueGtag from "vue-gtag";

Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: { 
    id: "G-7VW2B2TZPM", 
    anonymize_ip: true, 
    allow_google_signals: false,
    allow_ad_personalization_signals: false 
  },
  appName: 'Helpie',
  pageTrackerScreenviewEnabled: true
}, router);



Vue.use(new VueSocketIO({
    debug: true,
    connection: 'https://toolie.se',
    vuex: {
        store,
        actionPrefix: 'SOCKET_',
        mutationPrefix: 'SOCKET_'
    },
    options: { 
      path: "/helpie/socket.io/" 
    }
}))

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
